import React from 'react';
import { FiHeart, FiX, FiTrash2, FiDownload } from 'react-icons/fi';

const LikedVisualsDrawer = ({
    isOpen,
    onClose,
    likedVisuals,
    onUnlike,
    onClearAll,
    onVisualClick,
    onBulkDownload,
    isBulkDownloading
}) => {
    if (!isOpen) return null;

    return (
        <>
            <div className="liked-drawer-overlay" onClick={onClose} />
            <div className={`liked-drawer ${isOpen ? 'open' : ''}`}>
                <div className="liked-drawer-header">
                    <div className="liked-drawer-title">
                        <FiHeart size={18} color="#e74c3c" />
                        <h3>Liked Visuals</h3>
                        <span className="liked-drawer-count">{likedVisuals.length}</span>
                    </div>
                    <div className="liked-drawer-actions">
                        {likedVisuals.length > 0 && (
                            <button
                                className={`liked-drawer-download-all ${isBulkDownloading ? 'processing' : ''}`}
                                onClick={onBulkDownload}
                                disabled={isBulkDownloading}
                                title={isBulkDownloading ? "Processing downloads..." : "Download all liked visuals as spec sheets"}
                            >
                                {isBulkDownloading ? <div className="spinner-small" /> : <FiDownload size={18} />}
                            </button>
                        )}
                        <button className="liked-drawer-close" onClick={onClose}>
                            <FiX size={20} />
                        </button>
                    </div>
                </div>

                <div className="liked-drawer-body">
                    {likedVisuals.length === 0 ? (
                        <div className="liked-drawer-empty">
                            <FiHeart size={40} />
                            <p>No liked visuals yet</p>
                            <span>Tap the heart icon on any slab to save your favourite look</span>
                        </div>
                    ) : (
                        <div className="liked-drawer-list">
                            {likedVisuals.map((visual) => (
                                <div
                                    key={visual.id}
                                    className="liked-visual-card"
                                    onClick={() => {
                                        onVisualClick(visual.fullImage);
                                        onClose();
                                    }}
                                >
                                    {/* Slab info row */}
                                    <div className="liked-visual-slab-row">
                                        <img
                                            src={visual.image}
                                            alt={visual.label}
                                            className="liked-visual-slab-thumb"
                                            loading="lazy"
                                        />
                                        <div className="liked-visual-slab-info">
                                            <span className="liked-visual-label">{visual.label}</span>
                                            <span className="liked-visual-category">{visual.category}</span>
                                        </div>
                                        <button
                                            className="liked-visual-remove"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onUnlike(visual);
                                            }}
                                            title="Remove from liked"
                                        >
                                            <FiX size={14} />
                                        </button>
                                    </div>

                                    {/* Cabinet color indicator */}
                                    {visual.cabinetName && (
                                        <div className="liked-visual-cabinet">
                                            {visual.cabinetName === '2 Tone' ? (
                                                <>
                                                    <div className="liked-cabinet-2t-pill">
                                                        <div className="liked-cabinet-2t-swatch" />
                                                        <span className="liked-cabinet-label">2 Tone</span>
                                                    </div>
                                                    <div className="liked-cabinet-2t-cards">
                                                        {[
                                                            { role: 'UPPER', val: visual.upperCab },
                                                            { role: 'LOWER', val: visual.lowerCab },
                                                        ].map(({ role, val }) => {
                                                            const swatchSrc = val === 'W' ? '/mainpng2-white-cab.png' : val ? `/mainpng2-${val}-cab.png` : '/mainpng2-cab.png';
                                                            const colorNames = { '': 'Original', 'W': 'White', 'B': 'Blue', 'BL': 'Black', 'CR': 'Cream', 'G': 'Green' };
                                                            const colorName = colorNames[val] ?? val;
                                                            return (
                                                                <div key={role} className="liked-cabinet-2t-card">
                                                                    <span className="liked-cabinet-2t-role">{role}</span>
                                                                    <img src={swatchSrc} alt={colorName} className="liked-cabinet-2t-img" />
                                                                    <span className="liked-cabinet-2t-name">{colorName}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {visual.cabinetSwatch && (
                                                        <img
                                                            src={visual.cabinetSwatch}
                                                            alt={visual.cabinetName}
                                                            className="liked-cabinet-swatch"
                                                        />
                                                    )}
                                                    <span className="liked-cabinet-label">Cabinet: {visual.cabinetName}</span>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {/* Full application scene composite */}
                                    {visual.sceneImage && (
                                        <div className="liked-visual-scene">
                                            {visual.overlayImage && (
                                                <img
                                                    src={visual.overlayImage}
                                                    alt="Material"
                                                    className="liked-scene-base"
                                                    loading="lazy"
                                                />
                                            )}
                                            <img
                                                src={visual.sceneImage}
                                                alt={`${visual.application || 'Scene'}`}
                                                className="liked-scene-overlay"
                                                loading="lazy"
                                            />
                                            {/* 2-tone upper cabinet overlay */}
                                            {visual.cabinetColor === '2T' && (
                                                <img

                                                
                                                    alt="Upper cabinets"
                                                    className="liked-scene-overlay"
                                                    loading="lazy"
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {likedVisuals.length > 0 && (
                    <div className="liked-drawer-footer">
                        <button className="liked-drawer-clear" onClick={onClearAll}>
                            <FiTrash2 size={14} />
                            Clear All
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default LikedVisualsDrawer;
